import { Injectable } from '@angular/core';
import { Player } from './player.model';

@Injectable({ providedIn: 'root' })
export class LeaderBoardService {
    board = [{
        game: 'match_mitanim',
        kind: 'match',
        topPlayers: [
            new Player("07:54", 3000, "התאמה11", 1),
            new Player("06:54", 2000, "התאמה12", 1),
            new Player("09:54", 4000, "התאמה13", 1),
            new Player("02:54", 100, "התאמה14", 1),
            new Player("10:54", 5000, "התאמה15", 1),
        ]
    }, {
        game: 'match_nosaim',
        kind: 'match',
        topPlayers: [
            new Player("07:54", 3000, "התאמה21", 1),
            new Player("06:54", 2000, "התאמה22", 1),
            new Player("09:54", 4000, "התאמה23", 1),
            new Player("02:54", 100, "התאמה24", 1),
            new Player("10:54", 5000, "התאמה25", 1),
        ]
    }, {
        game: 'trivia_mitanim',
        kind: 'trivia',
        topPlayers: [
            new Player("07:54", 3000, "טריוויה11", 1),
            new Player("06:54", 2000, "טריוויה12", 1),
            new Player("09:54", 4000, "טריוויה13", 1),
            new Player("02:54", 100, "טריוויה14", 1),
            new Player("10:54", 5000, "טריוויה15", 1),
        ]
    }, {
        game: 'trivia_nosaim',
        kind: 'trivia',
        topPlayers: [
            new Player("07:54", 3000, "טריוויה21", 1),
            new Player("06:54", 2000, "טריוויה22", 1),
            new Player("09:54", 4000, "טריוויה23", 1),
            new Player("02:54", 100, "טריוויה24", 1),
            new Player("10:54", 5000, "טריוויה25", 1),
        ]
    }
    ]
    boardIndex = 0;


    constructor() { }

    addPlayer(name: string, score: number, time: string, total: number) {
        if (this.board[this.boardIndex].topPlayers.length == 5) {
            const lastPlace = this.getLastPlace();

            this.board[this.boardIndex].topPlayers = this.board[this.boardIndex].topPlayers.filter(player => {
                return player != lastPlace;
            });
        }
        console.log(time, score, name, total);

        this.board[this.boardIndex].topPlayers.push(new Player(time, score, name, total));
    }

    getFirstPlace() {
        const scoreList = this.board[this.boardIndex].topPlayers.map(player => {
            return player.score;
        });
        const championScore = Math.max(...scoreList);
        const champion = this.board[this.boardIndex].topPlayers.find(player => {
            if (championScore == player.score) {
                return player;
            } else {
                return;
            }
        });
        return champion;
    }

    getLastPlace() {
        const scoreList = this.board[this.boardIndex].topPlayers.map(player => {
            return player.score;
        });
        const looserScore = Math.min(...scoreList);
        const looser = this.board[this.boardIndex].topPlayers.find(player => {
            if (looserScore == player.score) {
                return player;
            } else {
                return;
            }
        });
        return looser;
    }

    getChampions() {
        let champions = [];
        this.board.forEach(gameBoard => {
            let champion: Player;
            let scoreList = gameBoard.topPlayers.map(player => player.score);
            let champScore = Math.max(...scoreList);
            champion = gameBoard.topPlayers.find(player => player.score == champScore);
            champions.push(champion);
        });
        return champions;
    }

    setBoardIndex(game: string) {
        this.board.forEach((board, index) => {
            if (board.game == game) {
                this.boardIndex = index;
            }
        });
    }

    resetBoard() {
        this.board = [{
            game: 'match_mitanim',
            kind: 'match',
            topPlayers: [
                new Player("07:54", 3000, "התאמה11", 1),
                new Player("06:54", 2000, "התאמה12", 1),
                new Player("09:54", 4000, "התאמה13", 1),
                new Player("02:54", 100, "התאמה14", 1),
                new Player("10:54", 5000, "התאמה15", 1),
            ]
        }, {
            game: 'match_nosaim',
            kind: 'match',
            topPlayers: [
                new Player("07:54", 3000, "התאמה21", 1),
                new Player("06:54", 2000, "התאמה22", 1),
                new Player("09:54", 4000, "התאמה23", 1),
                new Player("02:54", 100, "התאמה24", 1),
                new Player("10:54", 5000, "התאמה25", 1),
            ]
        }, {
            game: 'trivia_mitanim',
            kind: 'trivia',
            topPlayers: [
                new Player("07:54", 3000, "טריוויה11", 1),
                new Player("06:54", 2000, "טריוויה12", 1),
                new Player("09:54", 4000, "טריוויה13", 1),
                new Player("02:54", 100, "טריוויה14", 1),
                new Player("10:54", 5000, "טריוויה15", 1),
            ]
        }, {
            game: 'trivia_nosaim',
            kind: 'trivia',
            topPlayers: [
                new Player("07:54", 3000, "טריוויה21", 1),
                new Player("06:54", 2000, "טריוויה22", 1),
                new Player("09:54", 4000, "טריוויה23", 1),
                new Player("02:54", 100, "טריוויה24", 1),
                new Player("10:54", 5000, "טריוויה25", 1),
            ]
        }
        ]
    }
}